export default {
  halfs: array => {
    const median = Math.ceil(array.length / 2)
    return [
      array.slice(0, median),
      array.slice(median)
    ]
  },
  oddness: array => [
    array.filter((item, index) => index % 2 === 0),
    array.filter((item, index) => index % 2 === 1)
  ],
  distributeHorizontally: (array, n) => {
    if (n < 2) {
      return array
    }

    const chunks = []
    let totalChunks = 1
    let position = 0

    while (totalChunks <= n) {
      chunks.push([])
      totalChunks += 1
    }

    array.forEach(item => {
      if (position === n) {
        chunks[0].push(item)
        position = 1
      } else {
        chunks[position].push(item)
        position += 1
      }
    })

    return chunks
  }
}
